<template>
  <b-container fluid class="mosaics-container">
    <b-row>
      <b-col>
        <span class="mosaics-container-title">Seafloor Mosaics</span>
      </b-col>
    </b-row>
    <b-row class="mosaics-container-rows">
      <b-col>
        <b-list-group v-for="mosaic in mosaics" :key="mosaic.layerKey">
          <b-list-group-item
            class="mosaic-item"
            @click="zoomToMosaic(mosaic.zoomBounds)"
          >{{mosaic.name}}</b-list-group-item>
        </b-list-group>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
/* eslint-disable vue/multi-word-component-names */
import { mapState } from 'vuex';

const COGEO_BUCKET = `${process.env.COGEO_BUCKET}`;

export default {
  name: 'Mosaics',
  data() {
    return {
      mosaics: [
        {
          name: 'Ashes Mosaic',
          layerURL: `${COGEO_BUCKET}/mosaics/ashes_mosaic_cog.tif`,
          layerKey: 'ashes_mosaic',
          zoomBounds: [
            [-130.0141729267314, 45.93307339599995],
            [-130.01271635226854, 45.933924443],
          ],
        },
        {
          name: 'Einstein’s Grotto',
          layerURL: `${COGEO_BUCKET}/mosaics/R1463_4m_EG_GCS.tif`,
          layerKey: 'grotto',
          zoomBounds: [
            [-125.1469607, 44.5701122],
            [-125.1464911, 44.5698893],
          ],
        },
        {
          name: 'R1463 6M Z',
          layerURL: `${COGEO_BUCKET}/mosaics/R1463_6m_Z_gcs_cog.tif`,
          layerKey: 'R1463_6m_Z',
          zoomBounds: [
            [-125.14602857125, 44.570399835349995],
            [-125.14561959905, 44.57066015625],
          ],
        },
        {
          name: 'R1463 6M F',
          layerURL: `${COGEO_BUCKET}/mosaics/R1463_6m_F_gcs_cog.tif`,
          layerKey: 'R1463_6m_F',
          zoomBounds: [
            [-125.14742878884998, 44.569372877250004],
            [-125.14701221744998, 44.56960251155],
          ],
        },
        {
          name: 'R1463 6M HRF24',
          layerURL: `${COGEO_BUCKET}/mosaics/R1463_6m_HRF24_gcs_cog.tif`,
          layerKey: 'R1463_6m_HRF24',
          zoomBounds: [
            [-125.14772650574999, 44.56971464085001],
            [-125.14727438555, 44.569959570150004],
          ],
        },
        {
          name: 'R1463 6M RSNC',
          layerURL: `${COGEO_BUCKET}/mosaics/R1463_6m_RSNC_cog.tif`,
          layerKey: 'R1463_6m_RSNC',
          zoomBounds: [
            [-125.14725883735, 44.569410465249995],
            [-125.14662527014998, 44.56979377405],
          ],
        },
        {
          name: 'R1463 6M RSNE',
          layerURL: `${COGEO_BUCKET}/mosaics/R1463_6m_RSNE_cog.tif`,
          layerKey: 'R1463_6m_RSNE',
          zoomBounds: [
            [-125.14731288735, 44.57015365215],
            [-125.14673782755, 44.57060160245],
          ],
        },
      ],
    };
  },
  computed: {
    ...mapState({
      map: (state) => state.webmap,
    }),
  },
  methods: {
    zoomToMosaic(zoomBounds) {
      this.map.fitBounds(zoomBounds);
    },
  },
};
</script>

<style>
.mosaics-container {
  margin-top: 5px;
  margin-bottom: 5px;
}

.mosaics-container-rows {
  max-height: 150px;
  overflow-y: scroll;
}

.mosaics-container-title {
  font-weight: bold;
  font-size: 15px;
}

.mosaic-item {
  padding: 2px 0;
  border: 0;
  cursor: pointer;
}

.mosaic-item:hover {
  color: #3995a3;
}
</style>
